import React, { useRef } from "react"
import { Text, useScroll, Text3D } from "@react-three/drei"
import { useFrame } from "@react-three/fiber"
import { LayerMaterial, Depth, Fresnel } from "lamina"

export default function TextComponent({ weight, fs, position, rotation, txt, id, is3D, opacity }) {
  const scroll = useScroll()
  const ref = useRef()

  var gradient = 0.7

  useFrame((state) => {
    if (is3D) {
      const sin = Math.sin(state.clock.elapsedTime / 2)
      const cos = Math.cos(state.clock.elapsedTime / 2)
      ref.current.layers[0].origin.set(cos / 0.5, 0, 0)
      ref.current.layers[1].origin.set(cos, sin, cos)
      ref.current.layers[2].origin.set(sin, cos, sin)
      ref.current.layers[3].origin.set(cos, sin, cos)
    }
  })

  const onAction = () => {
    // scroll to next section
    console.log("scroll", scroll)

    if (id == "qs") {
      scroll.el.scrollTo({
        top: scroll.el.scrollHeight / 5,
        behavior: "smooth",
      })
    }

 

    if (id == "proyectos") {
      scroll.el.scrollTo({
        top: scroll.el.scrollHeight / 3.5,
        behavior: "smooth",
      })
    }

    if (id == "juegos") {
      scroll.el.scrollTo({
        top: scroll.el.scrollHeight / 2,
        behavior: "smooth",
      })
    }

    if (id == "contacto") {
      scroll.el.scrollTo({
        top: scroll.el.scrollHeight,
        behavior: "smooth",
      })
    }
  }

  if (!is3D) {
    return (
      <Text
        font={weight == "light" ? "/fonts/Ki-Light.otf" : "/fonts/Ki-Bold.otf"}
        fontSize={fs}
        position={position}
        rotation={rotation}
        onPointerDown={onAction}>
        {txt.toUpperCase()}
      </Text>
    )
  } else {
    return (
      <Text font={"/fonts/Ki-Light.otf"} scale={1} position={position}>
        {txt.toUpperCase()}
        <LayerMaterial ref={ref} toneMapped={false} transparent opacity={opacity}>
          <Depth colorA="#00FF38" colorB="black" alpha={1} mode="normal" near={0.5 * gradient} far={0.5} origin={[0, 0, 0]} />
          <Depth colorA="blue" colorB="#f7b955" alpha={1} mode="add" near={2 * gradient} far={2} origin={[0, 1, 1]} />
          <Depth colorA="green" colorB="#f7b955" alpha={1} mode="add" near={3 * gradient} far={3} origin={[0, 1, -1]} />
          <Depth colorA="white" colorB="red" alpha={1} mode="overlay" near={1.5 * gradient} far={1.5} origin={[1, -1, -1]} />
          <Fresnel mode="add" color="white" intensity={0.5} power={1.5} bias={0.05} />
        </LayerMaterial>
        {/* <Edges color="white" />  */}
      </Text>
    )
  }
}
